import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ProviderLayout from '../../components/ProviderLayout';
import { apiFetch } from '../../api';
import { formatDateTime } from '../../lib/datetime';

function asArr(d) {
  if (Array.isArray(d)) return d;
  if (d && Array.isArray(d.items)) return d.items;
  if (d && Array.isArray(d.data)) return d.data;
  return [];
}

export default function ProviderNotificationsPage() {
  const { auth } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/provider/notifications', auth.token);
      if (!res.ok) throw new Error();
      setItems(asArr(await res.json()));
    } catch {
      setItems([]);
      setError('Bildirishnomalarni yuklashda xatolik yuz berdi.');
    } finally {
      setLoading(false);
    }
  }, [auth.token]);

  useEffect(() => { load(); }, [load]);

  return (
    <ProviderLayout title="Bildirishnomalar">
      {loading ? (
        <div style={s.center}>Yuklanmoqda...</div>
      ) : error ? (
        <div style={s.error}>{error}</div>
      ) : items.length === 0 ? (
        <div style={s.empty}>
          <div style={s.emptyIcon}>🔔</div>
          <p style={s.emptyText}>Bildirishnoma yo'q</p>
          <p style={s.emptyHint}>Yangi bildirishnomalar shu yerda paydo bo'ladi.</p>
        </div>
      ) : (
        items.map((n, i) => (
          <div key={n.id ?? i} style={{ ...s.card, ...(n.read || n.isRead ? {} : s.cardUnread) }}>
            <div style={s.cardTop}>
              <span style={s.cardTitle}>{n.title || 'Bildirishnoma'}</span>
              {formatDateTime(n.createdAt) && <span style={s.date}>{formatDateTime(n.createdAt)}</span>}
            </div>
            {(n.body || n.message) && <p style={s.body}>{n.body || n.message}</p>}
          </div>
        ))
      )}
    </ProviderLayout>
  );
}

const PRIMARY = '#4F46E5';
const s = {
  center: { textAlign: 'center', padding: '48px', color: 'var(--slate-400)' },
  error: {
    background: 'var(--danger-tint)',
    border: '1px solid #FCA5A5',
    borderRadius: '10px',
    padding: '12px 14px',
    color: 'var(--danger)',
    fontSize: '14px',
  },
  empty: { textAlign: 'center', padding: '48px 16px' },
  emptyIcon: { fontSize: '40px', marginBottom: '10px' },
  emptyText: { margin: '0 0 4px', fontSize: '16px', fontWeight: '600', color: '#334155' },
  emptyHint: { margin: 0, fontSize: '14px', color: 'var(--slate-400)' },
  card: {
    background: 'var(--surface)',
    borderRadius: '14px',
    border: '1px solid #E2E8F0',
    padding: '14px 16px',
    marginBottom: '10px',
  },
  cardUnread: { borderColor: PRIMARY, background: '#F5F5FF' },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '8px' },
  cardTitle: { fontSize: '15px', fontWeight: '700', color: 'var(--slate-900)' },
  date: { fontSize: '12px', color: 'var(--slate-400)', whiteSpace: 'nowrap' },
  body: { fontSize: '14px', color: '#475569', margin: '6px 0 0', lineHeight: 1.4 },
};
